import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { IonSlides, Platform } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { Router } from '@angular/router';
import { from, Observable } from 'rxjs';
// import { UIService } from '@1bill-app/services/ui.service';
import { CardData } from '@1bill-app/services/home/home.type';
/**
 * Component for displaying action cards such as credit score,
 * add credit card, setup payment notifications.
 * 
 */
@Component({
  selector: 'app-action-cards',
  styleUrls: ['./action-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="swiper" *ngIf="list?.length">
      <div class="nav-wrapper">
        <div *ngIf="(isBeginning$ | async) === false" class="nav prev" (click)="prevSlide()">
          <ion-icon name="chevron-back"></ion-icon>
        </div>
        <div *ngIf="(isEnd$ | async) === false" class="nav next" (click)="nextSlide()">
          <ion-icon name="chevron-forward"></ion-icon>
        </div>
      </div>
      <ion-slides pager="false" [options]="slideOpts" 
        (ionSlideWillChange)="updateSliderIconState()" 
        (ionSlidesDidLoad)="updateSliderIconState()" 
        (ionSlideReachEnd)="updateSliderIconState()" 
        (ionSlideReachStart)="updateSliderIconState()" 
      >
        <ion-slide *ngFor="let card of list; let i = index; trackBy: trackByFn">
          <ion-card class="ion-text-start" color="{{ getCardColor(i) }}">
            <ion-card-content>
              <ion-icon [name]="card.icon"></ion-icon>
              <strong>{{ card.title }}</strong>
              <p>{{ card.description }}</p>
              <ion-button
                fill="outline"
                color="light"
                mode="ios"
                [routerLink]="getCardUrl(card)"
                [queryParams]="getQueryParamMap(card.title)"
              >
                {{ card.btnLabel }}
              </ion-button>
            </ion-card-content>
          </ion-card>
        </ion-slide>
      </ion-slides>
    </div>
  `,
})
export class ActionCardsComponent implements OnInit, AfterViewInit {
  @ViewChild(IonSlides) slides: IonSlides;
  slideOpts = {
    direction: 'horizontal',
    initialSlide: 0,
    slidesPerView: 'auto',
    spaceBetween: 15,
    slidesOffsetBefore: 15,
    slidesOffsetAfter: 15,

    freeModeSticky: (this.platform.is('android') || this.platform.is('ios')),
    freeModeMomentumBounce: false,
    freeModeMomentumRatio: 0.5,
    freeModeMomentumVelocityRatio: 0.5,
    // grabCursor: true,
  };
  colors = ['card-1', 'card-2'];
  @Input() billEmailAddress: string;
  @Input() list: CardData[];

  isBeginning$: Observable<boolean>;
  isEnd$: Observable<boolean>;

  // isSplitPaneVisible$ = this.uiService.isSplitPaneVisible$;
  constructor(
    private logger: NGXLogger,
    private router: Router,
    private platform: Platform,
    private cdRef: ChangeDetectorRef,
    //  private uiService: UIService,
  ) { }
  async ngOnInit() {
    this.logger.debug('cards data: ', this.list);
  }
  ngAfterViewInit() {
  }
  getCardUrl(card) {
    // if (card.url === '/email-bills') {
    //   return card.url + '/' + this.billEmailAddress;
    // }
    return card.url;

  }
  getCardColor(cardIndex: number) {
    const pos = cardIndex + 1;
    const colorIndex = pos % 2 === 0 ? 2 : pos % 2;
    return this.colors[colorIndex - 1];
  }
  getQueryParamMap(cardTitle) {
    const currentUrl = this.router.url;
    let queryParams = { prev: currentUrl }
    if (cardTitle.toLocaleLowerCase().split(" ").join("-") === 'send-via-email') {
      queryParams = { ...queryParams, ...{ directEmail: true } }
    }
    return queryParams;
  }
  trackByFn(index: number, item: any) {
    return item.id;
  }
  nextSlide() {
    if (this.slides) {
      this.slides.slideNext();
    }
  }
  prevSlide() {
    if (this.slides) {
      this.slides.slidePrev();
    }
  }
  updateSliderIconState() {
    this.isEnd$ = from(this.slides.isEnd());
    this.isBeginning$ = from(this.slides.isBeginning());
    this.cdRef.detectChanges();
  }
}
